import { useEffect, useRef } from 'react';

export default function Investment() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-item').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="investment" className="bg-[#F5F5F5] py-28" ref={sectionRef}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">

        {/* Header */}
        <div className="reveal-item opacity-0 translate-y-8 transition-all duration-700 mb-4 text-center">
          <span className="inline-block border border-[#2A2A2A]/20 rounded-full px-6 py-2 text-[#2A2A2A] text-xs uppercase tracking-[0.3em]">
            Investment
          </span>
        </div>
        <div className="reveal-item opacity-0 translate-y-8 transition-all duration-700 text-center mb-6">
          <h2 className="text-4xl md:text-5xl font-playfair text-[#2A2A2A]">
            Mining Assets &amp; <em className="text-[#6A6A6A]">Logistics Infrastructure</em>
          </h2>
        </div>
        <div className="reveal-item opacity-0 translate-y-8 transition-all duration-700 text-center mb-16">
          <p className="text-[#6A6A6A] text-lg max-w-2xl mx-auto leading-relaxed">
            Bulk Ore is actively pursuing investments in mining assets and logistics infrastructure to build a vertically integrated presence across global commodity supply chains — from resource extraction through to delivery.
          </p>
        </div>

        {/* Bottom CTA strip */}
        <div className="reveal-item opacity-0 translate-y-8 transition-all duration-700 rounded-2xl overflow-hidden relative">
          <img
            src="https://public.readdy.ai/ai/img_res/03049b537d50ac4c8c8a29d153f4c867.jpg"
            alt="Mining Investment"
            className="w-full h-[260px] object-cover object-center"
          />
          <div className="absolute inset-0 bg-[#1A1A1A]/70" />
          <div className="absolute inset-0 flex flex-col sm:flex-row items-center justify-between px-10 py-8 gap-6">
            <div>
              <p className="text-white/60 text-xs uppercase tracking-widest mb-2">Partner With Us</p>
              <h4 className="text-white text-2xl md:text-3xl font-playfair">Explore Investment Opportunities</h4>
            </div>
            <button
              onClick={() => {
                const el = document.querySelector('#contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="whitespace-nowrap flex-shrink-0 px-8 py-3.5 bg-white text-[#2A2A2A] text-sm font-semibold uppercase tracking-widest rounded-full hover:bg-[#E0E0E0] transition-all duration-300 cursor-pointer"
            >
              Get In Touch
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
